import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentMenuSelection: "",
  currentMenuTitle: "",
};

export const menuSelectorSlice = createSlice({
  name: "setMenuSelection",
  initialState,
  reducers: {
    setMenuSelection: (state, action) => {
        if (action.payload?.currentMenuSelection !== undefined) {
            state.currentMenuSelection = action.payload.currentMenuSelection;
          }
        if (action.payload?.currentMenuTitle !== undefined) {
            state.currentMenuTitle = action.payload.currentMenuTitle;
        }
    },
  },
});


export const { setMenuSelection } = menuSelectorSlice.actions;